import { createSelector } from 'reselect';

import { groupJobOrdersByStartDate } from '../../utils/jobOrderHelpers';

export const selectJobOrdersV2State = (state) => state?.jobOrdersV2State;

export const selectJobOrdersV2Loading = createSelector(
  selectJobOrdersV2State,
  (s) => s?.isJobOrdersV2Loading || false
);

export const selectJobOrdersV2 = createSelector(
  selectJobOrdersV2State,
  (s) => s?.jobOrdersV2 || []
);

export const selectJobOrdersV2Cursor = createSelector(selectJobOrdersV2State, (s) => s?.cursorV2);

export const selectJobOrdersV2HasMore = createSelector(
  selectJobOrdersV2State,
  (s) => s?.hasMoreV2 || false
);

export const selectJobOrdersV2GroupedByStart = createSelector(selectJobOrdersV2, (jobOrders) =>
  groupJobOrdersByStartDate(jobOrders)
);

export const selectTimeCardIsUpdatingV2 = createSelector(
  selectJobOrdersV2State,
  (s) => s?.timeCardIsUpdatingV2 || false
);

export const selectTimecardUpdateErrorV2 = createSelector(
  selectJobOrdersV2State,
  (s) => s?.timecardUpdateErrorV2 || null
);
